export const artifact1DataRevised = {
  id: "restaurant-app-market-research",
  type: "artifact",
  name: "Market Research",
  createdAt: "2025-03-20T08:00:00Z",
  guid: "uuid-artifact-001",
  label: "Market Research Artifact Label",
  path: "restaurant-app-market-research",
  children: [
    // Introduction
    {
      id: "intro",
      type: "text",
      content: "This Market Research artifact explores competitors and user needs for our restaurant discovery app. Insights here drive Product Requirements, with AI tools and iterative loops showcasing CrossContext’s power.",
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T08:05:00Z",
      guid: "uuid-text-intro-001",
      label: "Introduction Text Block",
      path: "restaurant-app-market-research/introduction",
    },
    // Competitor Analysis
    {
      id: "competitor-analysis",
      type: "section",
      heading: {
        id: "competitor-analysis-heading",
        type: "heading",
        content: "Competitor Analysis",
        level: 2,
        createdAt: "2025-03-20T08:10:00Z",
        guid: "uuid-heading-comp-analysis-001",
        label: "Competitor Analysis Heading", // Label for the heading block itself
        path: "restaurant-app-market-research/competitor-analysis/heading"
      },
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T08:15:00Z",
      guid: "uuid-section-comp-analysis-001",
      label: "Competitor Analysis Section", // Label for the section block
      path: "restaurant-app-market-research/competitor-analysis",
      children: [
        {
          id: "comp-yelp",
          type: "section",
          heading: {
            id: "comp-yelp-heading",
            type: "heading",
            level: 3,
            content: "Yelp",
            createdAt: "2025-03-20T08:20:00Z",
            guid: "uuid-heading-comp-yelp-001",
            label: "Yelp Heading",
            path: "restaurant-app-market-research/competitor-analysis/yelp/heading"
          },
          parent: "competitor-analysis",
          createdAt: "2025-03-20T08:25:00Z",
          guid: "uuid-section-comp-yelp-001",
          label: "Yelp Competitor Subsection",
          path: "restaurant-app-market-research/competitor-analysis/yelp",
          children: [
            {
              id: "comp-yelp-strengths",
              type: "text",
              content: "Strengths: Extensive database (1.2M+ restaurants), robust user reviews (avg. 4.3 stars).",
              parent: "comp-yelp",
              createdAt: "2025-03-20T08:30:00Z",
              guid: "uuid-text-yelp-strength-001",
              label: "Yelp Strengths",
              path: "restaurant-app-market-research/competitor-analysis/yelp/strengths",
              sources: [{ iri: "#", attribution: "Yelp Website" }],
            },
            {
              id: "comp-yelp-weaknesses",
              type: "text",
              content: "Weaknesses: Cluttered UI (30% longer search times), lacks dietary filters.",
              parent: "comp-yelp",
              createdAt: "2025-03-20T08:35:00Z",
              guid: "uuid-text-yelp-weak-001",
              label: "Yelp Weaknesses",
              path: "restaurant-app-market-research/competitor-analysis/yelp/weaknesses",
              sources: [{ iri: "#", attribution: "Yelp Website" }],
            },
          ],
        },
         {
          id: "comp-google-maps",
          type: "section",
          heading: {
            id: "comp-google-maps-heading",
            type: "heading",
            level: 3,
            content: "Google Maps",
            createdAt: "2025-03-20T08:40:00Z",
            guid: "uuid-heading-comp-gmaps-001",
            label: "Google Maps Heading",
            path: "restaurant-app-market-research/competitor-analysis/google-maps/heading"
          },
          parent: "competitor-analysis",
          createdAt: "2025-03-20T08:45:00Z",
          guid: "uuid-section-comp-gmaps-001",
          label: "Google Maps Competitor Subsection",
          path: "restaurant-app-market-research/competitor-analysis/google-maps",
          children: [
             {
              id: "comp-google-maps-strengths",
              type: "text",
              content: "Strengths: Superior map integration, real-time location data (90% coverage).",
              parent: "comp-google-maps",
              createdAt: "2025-03-20T08:50:00Z",
              guid: "uuid-text-gmaps-strength-001",
              label: "Google Maps Strengths",
              path: "restaurant-app-market-research/competitor-analysis/google-maps/strengths",
              sources: [{ iri: "#", attribution: "Google Maps" }],
            },
            {
              id: "comp-google-maps-weaknesses",
              type: "text",
              content: "Weaknesses: Limited filters (cuisine, distance only), minimal review depth.",
              parent: "comp-google-maps",
              createdAt: "2025-03-20T08:55:00Z",
               guid: "uuid-text-gmaps-weak-001",
              label: "Google Maps Weaknesses",
              path: "restaurant-app-market-research/competitor-analysis/google-maps/weaknesses",
              sources: [{ iri: "#", attribution: "Google Maps" }],
            },
          ]
        },
        {
          id: "comp-opentable",
          type: "section",
          heading: {
             id: "comp-opentable-heading",
             type: "heading",
             level: 3,
             content: "OpenTable",
             createdAt: "2025-03-20T09:00:00Z",
             guid: "uuid-heading-comp-opentable-001",
             label: "OpenTable Heading",
             path: "restaurant-app-market-research/competitor-analysis/opentable/heading"
           },
          parent: "competitor-analysis",
          createdAt: "2025-03-20T09:05:00Z",
          guid: "uuid-section-comp-opentable-001",
          label: "OpenTable Competitor Subsection",
          path: "restaurant-app-market-research/competitor-analysis/opentable",
          children: [
             {
              id: "comp-opentable-strengths",
              type: "text",
              content: "Strengths: Seamless reservations, 50K+ restaurant partners.",
              parent: "comp-opentable",
              createdAt: "2025-03-20T09:10:00Z",
              guid: "uuid-text-opentable-strength-001",
              label: "OpenTable Strengths",
              path: "restaurant-app-market-research/competitor-analysis/opentable/strengths",
              sources: [{ iri: "#", attribution: "OpenTable" }],
            },
            {
              id: "comp-opentable-weaknesses",
              type: "text",
              content: "Weaknesses: Focuses on high-end dining, lacks casual options.",
              parent: "comp-opentable",
              createdAt: "2025-03-20T09:15:00Z",
              guid: "uuid-text-opentable-weak-001",
              label: "OpenTable Weaknesses",
              path: "restaurant-app-market-research/competitor-analysis/opentable/weaknesses",
              sources: [{ iri: "#", attribution: "OpenTable" }],
            },
          ]
        },
      ],
    },
    // User Feedback
    {
      id: "user-feedback",
      type: "section",
      heading: {
        id: "user-feedback-heading",
        type: "heading",
        level: 2,
        content: "User Feedback",
        createdAt: "2025-03-20T09:20:00Z",
        guid: "uuid-heading-user-feedback-001",
        label: "User Feedback Heading",
        path: "restaurant-app-market-research/user-feedback/heading"
      },
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T09:25:00Z",
      guid: "uuid-section-user-feedback-001",
      label: "User Feedback Section",
      path: "restaurant-app-market-research/user-feedback",
      children: [
        {
          id: "feedback-search",
          type: "section",
          heading: {
             id: "feedback-search-heading",
             type: "heading",
             level: 3,
             content: "Search and Filtering",
             createdAt: "2025-03-20T09:30:00Z",
             guid: "uuid-heading-feedback-search-001",
             label: "Search Feedback Heading",
             path: "restaurant-app-market-research/user-feedback/search/heading"
           },
          parent: "user-feedback",
          createdAt: "2025-03-20T09:35:00Z",
          guid: "uuid-section-feedback-search-001",
          label: "Search Feedback Subsection",
          path: "restaurant-app-market-research/user-feedback/search",
          children: [
             {
                id: "feedback-search-vegan",
                type: "text",
                content: "'I need vegan options fast – current apps make me scroll endlessly.'",
                parent: "feedback-search",
                createdAt: "2025-03-20T09:40:00Z",
                guid: "uuid-text-feedback-vegan-001",
                label: "Feedback: Vegan Search",
                path: "restaurant-app-market-research/user-feedback/search/vegan-quote",
                sources: [{ iri: "#", attribution: "App Store Review" }],
             },
             {
                id: "feedback-search-price",
                type: "text",
                content: "'Filters for price ranges are a must – $20 dinners shouldn’t mix with $50 ones.'",
                parent: "feedback-search",
                createdAt: "2025-03-20T09:45:00Z",
                guid: "uuid-text-feedback-price-001",
                label: "Feedback: Price Filter",
                path: "restaurant-app-market-research/user-feedback/search/price-quote",
                sources: [{ iri: "#", attribution: "User Survey" }],
             },
          ]
        },
        {
          id: "feedback-menus",
          type: "section",
          heading: {
            id: "feedback-menus-heading",
            type: "heading",
            level: 3,
            content: "Menu Accuracy",
            createdAt: "2025-03-20T09:50:00Z",
            guid: "uuid-heading-feedback-menus-001",
            label: "Menu Accuracy Heading",
            path: "restaurant-app-market-research/user-feedback/menus/heading"
          },
          parent: "user-feedback",
          createdAt: "2025-03-20T09:55:00Z",
          guid: "uuid-section-feedback-menus-001",
          label: "Menu Accuracy Feedback",
          path: "restaurant-app-market-research/user-feedback/menus",
          children: [
            {
              id: "feedback-menus-accuracy",
              type: "text",
              content: "'Last week’s menu was off by $5 – apps need real-time updates!'",
              parent: "feedback-menus",
              createdAt: "2025-03-20T10:00:00Z",
              guid: "uuid-text-feedback-menu-acc-quote-001",
              label: "Feedback: Menu Accuracy Quote",
              path: "restaurant-app-market-research/user-feedback/menus/accuracy-quote",
              sources: [{ iri: "#", attribution: "Online Forum" }],
            },
          ],
        },
        {
          id: "feedback-maps",
          type: "section",
          heading: {
            id: "feedback-maps-heading",
            type: "heading",
            level: 3,
            content: "Map Integration",
            createdAt: "2025-03-20T10:05:00Z",
            guid: "uuid-heading-feedback-maps-001",
            label: "Map Integration Heading",
            path: "restaurant-app-market-research/user-feedback/maps/heading"
          },
          parent: "user-feedback",
          createdAt: "2025-03-20T10:10:00Z",
          guid: "uuid-section-feedback-maps-001",
          label: "Map Integration Feedback",
          path: "restaurant-app-market-research/user-feedback/maps",
          children: [
            {
              id: "feedback-maps-usability",
              type: "text",
              content: "'Love seeing restaurants on a map, but I need clear ratings too.'",
              parent: "feedback-maps",
              createdAt: "2025-03-20T10:15:00Z",
              guid: "uuid-text-feedback-map-usability-quote-001",
              label: "Feedback: Map Usability Quote",
              path: "restaurant-app-market-research/user-feedback/maps/usability-quote",
              sources: [{ iri: "#", attribution: "User Interview" }],
            },
          ],
        },
        {
          id: "feedback-reservations",
          type: "section",
          heading: {
            id: "feedback-reservations-heading",
            type: "heading",
            level: 3,
            content: "Reservations",
            createdAt: "2025-03-20T10:20:00Z",
            guid: "uuid-heading-feedback-reservations-001",
            label: "Reservations Feedback Heading",
            path: "restaurant-app-market-research/user-feedback/reservations/heading"
          },
          parent: "user-feedback",
          createdAt: "2025-03-20T10:25:00Z",
          guid: "uuid-section-feedback-reservations-001",
          label: "Reservations Feedback",
          path: "restaurant-app-market-research/user-feedback/reservations",
          children: [
            {
              id: "feedback-reservations-ease",
              type: "text",
              content: "'I’d love to book a table directly – searching and calling is a hassle.'",
              parent: "feedback-reservations",
              createdAt: "2025-03-20T10:30:00Z",
              guid: "uuid-text-feedback-reservation-ease-quote-001",
              label: "Feedback: Reservation Ease Quote",
              path: "restaurant-app-market-research/user-feedback/reservations/ease-quote",
              sources: [{ iri: "#", attribution: "User Survey" }],
            },
          ],
        },
        {
          id: "feedback-social",
          type: "section",
          heading: {
            id: "feedback-social-heading",
            type: "heading",
            level: 3,
            content: "Social Features",
            createdAt: "2025-03-20T10:35:00Z",
            guid: "uuid-heading-feedback-social-001",
            label: "Social Features Heading",
            path: "restaurant-app-market-research/user-feedback/social/heading"
          },
          parent: "user-feedback",
          createdAt: "2025-03-20T10:40:00Z",
          guid: "uuid-section-feedback-social-001",
          label: "Social Features Feedback",
          path: "restaurant-app-market-research/user-feedback/social",
          children: [
            {
              id: "feedback-social-sharing",
              type: "text",
              content: "'Sharing great finds with friends would make this app a go-to.'",
              parent: "feedback-social",
              createdAt: "2025-03-20T10:45:00Z",
              guid: "uuid-text-feedback-social-share-quote-001",
              label: "Feedback: Social Sharing Quote",
              path: "restaurant-app-market-research/user-feedback/social/sharing-quote",
              sources: [{ iri: "#", attribution: "User Interview" }],
            },
          ],
        },
        {
          id: "feedback-speed",
          type: "section",
          heading: {
            id: "feedback-speed-heading",
            type: "heading",
            level: 3,
            content: "App Speed",
            createdAt: "2025-03-20T10:50:00Z",
            guid: "uuid-heading-feedback-speed-001",
            label: "App Speed Heading",
            path: "restaurant-app-market-research/user-feedback/speed/heading"
          },
          parent: "user-feedback",
          createdAt: "2025-03-20T10:55:00Z",
          guid: "uuid-section-feedback-speed-001",
          label: "App Speed Feedback",
          path: "restaurant-app-market-research/user-feedback/speed",
          children: [
            {
              id: "feedback-speed-performance",
              type: "text",
              content: "'Slow load times kill the vibe – make it snappy!'",
              parent: "feedback-speed",
              createdAt: "2025-03-20T11:00:00Z",
              guid: "uuid-text-feedback-speed-perf-quote-001",
              label: "Feedback: App Speed Quote",
              path: "restaurant-app-market-research/user-feedback/speed/performance-quote",
              sources: [{ iri: "#", attribution: "App Store Review" }],
            },
          ],
        },
      ],
    },
    // Target Audience
    {
      id: "target-audience",
      type: "section",
      heading: {
        id: "target-audience-heading",
        type: "heading",
        level: 2,
        content: "Target Audience",
        createdAt: "2025-03-20T11:05:00Z",
        guid: "uuid-heading-target-audience-001",
        label: "Target Audience Heading",
        path: "restaurant-app-market-research/target-audience/heading"
      },
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T11:10:00Z",
      guid: "uuid-section-target-audience-001",
      label: "Target Audience Section",
      path: "restaurant-app-market-research/target-audience",
      children: [
        {
          id: "audience-description",
          type: "text",
          content: "25-40-year-olds (60% urban), food enthusiasts with dietary needs (30% vegan/gluten-free), travelers, and social diners who value speed and sharing.",
          parent: "target-audience",
          createdAt: "2025-03-20T11:15:00Z",
          guid: "uuid-text-audience-desc-001",
          label: "Audience Description",
          path: "restaurant-app-market-research/target-audience/description",
          sources: [{
            iri: "artifact://restaurant-app-market-research/user-feedback",
            attribution: "User Feedback Analysis",
          }],
        },
      ],
    },
    // AI-Assisted Analysis
    {
      id: "ai-assisted-analysis",
      type: "section",
      heading: {
        id: "ai-assisted-analysis-heading",
        type: "heading",
        level: 2,
        content: "AI-Assisted Analysis",
        createdAt: "2025-03-20T11:20:00Z",
        guid: "uuid-heading-ai-analysis-001",
        label: "AI Analysis Heading",
        path: "restaurant-app-market-research/ai-analysis/heading"
      },
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T11:25:00Z",
      guid: "uuid-section-ai-analysis-001",
      label: "AI Analysis Section",
      path: "restaurant-app-market-research/ai-analysis",
      children: [
        {
          id: "needs-lens",
          type: "lens",
          prompt: "Extract key user needs from feedback",
          sources: [{
            iri: "artifact://restaurant-app-market-research/user-feedback",
            attribution: "User Feedback",
          }],
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-20T11:30:00Z",
          guid: "uuid-lens-needs-001",
          label: "Lens: Extract User Needs",
          path: "restaurant-app-market-research/ai-analysis/needs-lens",
          result: {
             id: "needs-lens-result",
             type: "list",
             ordered: true,
             parent: "needs-lens",
             createdAt: "2025-03-20T11:35:00Z",
             guid: "uuid-list-needs-lens-result-001", // GUID for the list block
             label: "User Needs List (Lens Result)",
             path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list",
             children: [
                { id: "needs-lens-result-1", type: "text", content: "Advanced search filters (dietary, price, location)", parent: "needs-lens-result", createdAt: "2025-03-20T11:40:00Z", guid: "uuid-text-needs-lens-res1-001", label: "Need: Search Filters", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item1"},
                { id: "needs-lens-result-2", type: "text", content: "Accurate, up-to-date menus", parent: "needs-lens-result", createdAt: "2025-03-20T11:45:00Z", guid: "uuid-text-needs-lens-res2-001", label: "Need: Accurate Menus", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item2"},
                { id: "needs-lens-result-3", type: "text", content: "Map integration with ratings", parent: "needs-lens-result", createdAt: "2025-03-20T11:50:00Z", guid: "uuid-text-needs-lens-res3-001", label: "Need: Map Integration", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item3"},
                { id: "needs-lens-result-4", type: "text", content: "Easy reservations", parent: "needs-lens-result", createdAt: "2025-03-20T11:55:00Z", guid: "uuid-text-needs-lens-res4-001", label: "Need: Easy Reservations", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item4"},
                { id: "needs-lens-result-5", type: "text", content: "Social sharing options", parent: "needs-lens-result", createdAt: "2025-03-20T12:00:00Z", guid: "uuid-text-needs-lens-res5-001", label: "Need: Social Sharing", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item5"},
                { id: "needs-lens-result-6", type: "text", content: "Fast app performance", parent: "needs-lens-result", createdAt: "2025-03-20T12:05:00Z", guid: "uuid-text-needs-lens-res6-001", label: "Need: Performance", path: "restaurant-app-market-research/ai-analysis/needs-lens/result-list/item6"},
             ]
          }
        },
        {
          id: "sentiment-lens",
          type: "lens",
          prompt: "Analyze sentiment from user feedback",
          sources: [{
            iri: "artifact://restaurant-app-market-research/user-feedback",
            attribution: "User Feedback",
          }],
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-20T12:10:00Z",
          guid: "uuid-lens-sentiment-001",
          label: "Lens: Analyze Sentiment",
          path: "restaurant-app-market-research/ai-analysis/sentiment-lens",
          result: {
            id: "sentiment-lens-result",
            type: "text",
            content: "Mixed sentiment: users value maps and reservations but are frustrated with filters, menus, and speed.",
            parent: "sentiment-lens",
            createdAt: "2025-03-20T12:15:00Z",
            guid: "uuid-text-sentiment-lens-res-001",
            label: "Sentiment Analysis Result",
            path: "restaurant-app-market-research/ai-analysis/sentiment-lens/result-text"
          },
        },
        {
          id: "gaps-lens",
          type: "lens",
          prompt: "Identify gaps between competitor offerings and user needs",
          sources: [ { iri: "artifact://restaurant-app-market-research/user-feedback", attribution: "User Feedback", }, { iri: "artifact://restaurant-app-market-research/competitor-analysis", attribution: "Competitor Analysis", }, ],
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-20T12:20:00Z",
          guid: "uuid-lens-gaps-001",
          label: "Lens: Identify Gaps",
          path: "restaurant-app-market-research/ai-analysis/gaps-lens",
          result: {
            id: "gaps-lens-result",
            type: "list",
            ordered: true,
            parent: "gaps-lens",
            createdAt: "2025-03-20T12:25:00Z",
            guid: "uuid-list-gaps-lens-result-001",
            label: "Competitor Gaps List (Lens Result)",
            path: "restaurant-app-market-research/ai-analysis/gaps-lens/result-list",
            children: [
              { id: "gaps-lens-result-1", type: "text", content: "Dietary filters (missing in Yelp/Google Maps)", parent: "gaps-lens-result", createdAt: "2025-03-20T12:30:00Z", guid: "uuid-text-gaps-lens-res1-001", label: "Gap: Dietary Filters", path: "restaurant-app-market-research/ai-analysis/gaps-lens/result-list/item1"},
              { id: "gaps-lens-result-2", type: "text", content: "Casual dining reservations (weak in OpenTable)", parent: "gaps-lens-result", createdAt: "2025-03-20T12:35:00Z", guid: "uuid-text-gaps-lens-res2-001", label: "Gap: Casual Reservations", path: "restaurant-app-market-research/ai-analysis/gaps-lens/result-list/item2"},
              { id: "gaps-lens-result-3", type: "text", content: "Social sharing (absent across all)", parent: "gaps-lens-result", createdAt: "2025-03-20T12:40:00Z", guid: "uuid-text-gaps-lens-res3-001", label: "Gap: Social Sharing", path: "restaurant-app-market-research/ai-analysis/gaps-lens/result-list/item3"},
            ],
          },
        },
        {
          id: "research-chat-1",
          type: "chat",
          name: "Competitor Analysis Chat",
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-20T12:45:00Z",
          guid: "uuid-chat-research1-001", // Corrected GUID prefix
          label: "Chat: Competitor Analysis",
          path: "restaurant-app-market-research/ai-analysis/competitor-chat",
          children: [
            {
              id: "research-chat-1-msg-1", type: "chatMessage", sender: "user", parent: "research-chat-1", createdAt: "2025-03-20T12:50:00Z", guid: "uuid-chatMessage-research1-msg1-001", label:"User Msg: Summarize Competitors", path:"restaurant-app-market-research/ai-analysis/competitor-chat/msg1",
              children: [ { id: "research-chat-1-msg-1-content", type: "text", content: "Summarize competitor strengths and weaknesses.", parent: "research-chat-1-msg-1", createdAt: "2025-03-20T12:55:00Z", guid: "uuid-text-research1-msg1-txt-001", label:"User Msg Content", path:"..."} ],
            },
            {
              id: "research-chat-1-msg-2", type: "chatMessage", sender: "ai", parent: "research-chat-1", createdAt: "2025-03-20T13:00:00Z", guid: "uuid-chatMessage-research1-msg2-001", label:"AI Msg: Competitor Summary", path:"restaurant-app-market-research/ai-analysis/competitor-chat/msg2",
              children: [ { id: "research-chat-1-msg-2-content", type: "text", content: "Strengths: Yelp (database), Google Maps (maps), OpenTable (reservations). Weaknesses: UI clutter, limited filters, niche focus.", parent: "research-chat-1-msg-2", createdAt: "2025-03-20T13:05:00Z", guid: "uuid-text-research1-msg2-txt-001", label:"AI Msg Content", path:"..."} ],
            },
          ],
        },
        {
          id: "research-chat-2",
          type: "chat",
          name: "Favorites Research Chat",
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-22T09:00:00Z",
           guid: "uuid-chat-research2-001", label:"Chat: Favorites Research", path:"restaurant-app-market-research/ai-analysis/favorites-chat",
          children: [
            {
              id: "research-chat-2-msg-1", type: "chatMessage", sender: "user", parent: "research-chat-2", createdAt: "2025-03-22T09:05:00Z", guid: "uuid-chatMessage-research2-msg1-001", label:"User Msg: Favs Research", path:"...",
              children: [
                 { id: "research-chat-2-msg-1-content", type: "text", content: "How do competitors handle saving favorite restaurants? (Triggered by Product Requirements discussion)", parent: "research-chat-2-msg-1", createdAt: "2025-03-22T09:10:00Z", guid:"uuid-text-research2-msg1-txt-001", label:"User Msg Content", path:"..."},
                 { id: "research-chat-2-msg-1-ref", type: "reference", ref: "artifact://restaurant-app-requirements/req-chat", label: "Ref: Product Requirements > Requirements Chat", parent: "research-chat-2-msg-1", createdAt: "2025-03-22T09:15:00Z", guid:"uuid-reference-research2-msg1-ref-001", label:"Reference to Req Chat", path:"..." },
              ],
            },
            {
              id: "research-chat-2-msg-2", type: "chatMessage", sender: "ai", parent: "research-chat-2", createdAt: "2025-03-22T09:20:00Z", guid: "uuid-chatMessage-research2-msg2-001", label:"AI Msg: Favs Comp Analysis", path:"...",
              children: [ { id: "research-chat-2-msg-2-content", type: "text", content: "Yelp uses 'Bookmarks' (simple list), Google Maps has 'Saved Places' (map-linked). Both are popular but lack customization.", parent: "research-chat-2-msg-2", createdAt: "2025-03-22T09:25:00Z", guid:"uuid-text-research2-msg2-txt-001", label:"AI Msg Content", path:"..." } ],
            },
          ],
        },
        {
          id: "research-chat-3",
          type: "chat",
          name: "Social Sharing Research Chat",
          parent: "ai-assisted-analysis",
          createdAt: "2025-03-23T09:00:00Z",
          guid: "uuid-chat-research3-001", label:"Chat: Social Sharing Research", path:"restaurant-app-market-research/ai-analysis/social-chat",
          children: [
             {
              id: "research-chat-3-msg-1", type: "chatMessage", sender: "user", parent: "research-chat-3", createdAt: "2025-03-23T09:05:00Z", guid: "uuid-chatMessage-research3-msg1-001", label:"User Msg: Social Research", path:"...",
              children: [
                 { id: "research-chat-3-msg-1-content", type: "text", content: "Do users want social sharing features? (Triggered by Product Requirements next steps)", parent: "research-chat-3-msg-1", createdAt: "2025-03-23T09:10:00Z", guid:"uuid-text-research3-msg1-txt-001", label:"User Msg Content", path:"..." },
                 { id: "research-chat-3-msg-1-ref", type: "reference", ref: "artifact://restaurant-app-requirements/next-steps", label: "Ref: Product Requirements > Next Steps", parent: "research-chat-3-msg-1", createdAt: "2025-03-23T09:15:00Z", guid:"uuid-reference-research3-msg1-ref-001", label:"Reference to Next Steps", path:"..." },
              ],
            },
            {
              id: "research-chat-3-msg-2", type: "chatMessage", sender: "ai", parent: "research-chat-3", createdAt: "2025-03-23T09:20:00Z", guid: "uuid-chatMessage-research3-msg2-001", label:"AI Msg: Social Gap", path:"...",
              children: [
                 { id: "research-chat-3-msg-2-content", type: "text", content: "Yes, feedback suggests sharing is valued. Competitors lack this – could be a differentiator.", parent: "research-chat-3-msg-2", createdAt: "2025-03-23T09:25:00Z", guid:"uuid-text-research3-msg2-txt-001", label:"AI Msg Content", path:"..." },
                 { id: "research-chat-3-msg-2-ref", type: "reference", ref: "artifact://restaurant-app-market-research/feedback-social-sharing", label: "Ref: Social Sharing Feedback", parent: "research-chat-3-msg-2", createdAt: "2025-03-23T09:30:00Z", guid:"uuid-reference-research3-msg2-ref-001", label:"Reference to Social Feedback", path:"..." },
              ],
            },
          ],
        },
      ],
    },
    // Summary
    {
      id: "summary",
      type: "section",
      heading: {
        id: "summary-heading",
        type: "heading",
        level: 2,
        content: "Summary",
        createdAt: "2025-03-20T13:15:00Z",
        guid: "uuid-heading-summary-001", // Corrected prefix
        label: "Summary Heading",
        path: "restaurant-app-market-research/summary/heading"
      },
      parent: "restaurant-app-market-research",
      createdAt: "2025-03-20T13:20:00Z",
      guid: "uuid-section-summary-001", // Corrected prefix
      label: "Summary Section",
      path: "restaurant-app-market-research/summary",
      children: [
        {
          id: "summary-lens",
          type: "lens",
          prompt: "Synthesize a summary of market research, combining user needs and competitor analysis.",
          sources: [ { iri: "artifact://restaurant-app-market-research/needs-lens", attribution: "User Needs Lens", }, { iri: "artifact://restaurant-app-market-research/competitor-analysis", attribution: "Competitor Analysis", }, ],
          parent: "summary",
          createdAt: "2025-03-20T13:25:00Z",
          guid: "uuid-lens-summary-001", // Corrected prefix
          label: "Lens: Synthesize Summary",
          path: "restaurant-app-market-research/summary/synthesis-lens",
          result: {
            id: "summary-lens-result",
            type: "text",
            content: "Competitors excel in databases and maps but struggle with UI, filters, and catering to specific dietary needs.  Users prioritize advanced search functionality, accurate menus, integrated maps, reservation capabilities, and fast performance. A significant gap exists in providing comprehensive dietary filtering and social sharing options, presenting an opportunity for differentiation.",
            parent: "summary-lens",
            createdAt: "2025-03-20T13:30:00Z",
            guid: "uuid-text-summary-lens-res-001", // Corrected prefix
            label: "Market Research Summary",
            path: "restaurant-app-market-research/summary/synthesis-lens/result-text"
          },
        },
      ],
    },
  ],
};